import React, { forwardRef } from "react";
import styled, { css } from "styled-components";
import { Jumbotron as BootstrapJumbotron } from "react-bootstrap";
export const StyledJumbotron = styled(BootstrapJumbotron)(
  ({ theme }) => css`
    color: ${theme.colors.text.primary};
    background-color: ${theme.colors.global.contentBackground};

    h2 {
      font-weight: bold;
    }

    p {
      margin-bottom: 9px;
      font-size: 20px;
      font-weight: normal;
    }
  `
);
const Jumbotron = forwardRef(
  (props, ref) => /* @__PURE__ */ React.createElement(StyledJumbotron, { ref, ...props })
);
export default Jumbotron;
